var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.alt}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }